import { render, staticRenderFns } from "./crearPerfil.vue?vue&type=template&id=7aa43ed2&scoped=true"
import script from "./crearPerfil.vue?vue&type=script&lang=js"
export * from "./crearPerfil.vue?vue&type=script&lang=js"
import style0 from "./crearPerfil.vue?vue&type=style&index=0&id=7aa43ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa43ed2",
  null
  
)

export default component.exports